<template>
  <div class="part3-wrap" :class="{ 'part3-none': !flag }">
    <div class="title-wrap">
      <v-title class="title" :text="'我们的产品'" :color="'white'"></v-title>
    </div>
    <div class="pics" style="margin-top: 20px">
      <div class="item">
        <router-link to="/exchange">
          <window :data="winData[0]" :flag="flag"></window>
        </router-link>
      </div>
      <div class="item">
        <a href="https://anybit.io">
          <window :data="winData[1]" :flag="flag"></window>
        </a>
      </div>
      <div class="item">
        <router-link to="/heavyWallet">
          <window :data="winData[2]" :flag="flag"></window>
        </router-link>
      </div>
    </div>
    <div class="pics">
      <div class="item">
        <a href="http://www.anychain.org">
          <window :data="winData[3]" :flag="flag"></window>
        </a>
      </div>
      <div class="item">
        <a href="https://www.anybit.io/#/bankcard">
          <window :data="winData[4]" :flag="flag"></window>
        </a>
      </div>
      <div class="item">
        <a href="http://www.blocklinker.com/pixiu">
          <window :data="winData[5]" :flag="flag"></window>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import VTitle from "../plug/VTitle";
import Window from "./window/Window";

export default {
  components: {
    Window,
    VTitle,
  },
  props: ["flag"],
  name: "part3",
  data() {
    return {
      winData: [
        {
          num: "01",
          title: "交易所",
          url: "static/img/exchange.png",
          con:
            "网页端及移动端设计及开发，实现用户注册、实名认证、充值提现、货币交易、资产管理等基础功能，根据用户需要完成更多高级功能的开发与技术支持。",
        },
        {
          num: "02",
          title: "轻钱包",
          url: "static/img/wallet-light.png",
          con:
            "基于比特币/以太坊等数字货币钱包的定制开发，支持多种货币的接入，支持货币行情实时查询等增值服务，可为用户提供更安全、便捷、功能强大的数字资产管理服务。",
        },
        {
          num: "03",
          title: "重钱包",
          url: "static/img/wallet-weight.png",
          con:
            "基于公有链开发的重钱包客户端，包含区块链完整数据，实现区块链的完整功能和对外接口，跨平台，可作为冷热钱包和对外服务的底层使用（比如交易所、中间件）。用户在客户端上可实现币币交易、智能合约、多重签名、挖矿等功能。",
        },
        {
          num: "04",
          title: "AnyChain",
          url: "static/img/anychain.png",
          con:
            "支持多条公链及多种模板，AnyChain可以帮助开发者快速完成区块链智能合约的编写、编译、注册上链，并实现对应链的部分钱包功能，如账户管理、注册、转账等。 有助于提升效率、代码质量和高效协作。",
        },
        {
          num: "05",
          title: "硬件钱包-数银卡",
          url: "static/img/nfc.png",
          con:
            "基于智能卡及NFC的数字货币私钥保存方案定制，安全便携，完全匿名。适用多种场景，比如数字货币的现金、银行卡及冷钱包等。",
        },
        {
          num: "06",
          title: "beidou",
          url: "static/img/beidou.png",
          con:
            "“beidou”是一款十分好用的国学排盘工具,能够为广大国学用户提供实用便捷的辅助功能，该软件增加了许多辅助功能与提示，实用性强，操作特别简单，让用户们使用起来更便捷。",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.part3-wrap {
  height: 100%;
  overflow: hidden;
  position: relative;
  background: url("../../assets/img/part3-bg.jpg");
  background-size: 100% 100%;
  .title-wrap {
    position: relative;
    height: 12%;
    .title {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -100%);
    }
  }
  .pics {
    display: flex;
    /*justify-content: space-between;*/
    width: 90%;
    min-width: 1180px;
    height: 36%;
    min-height: 240px;
    margin: 40px auto 0;
    .item {
      flex: 1;
      height: 100%;
      box-shadow: 0px 0px 40px rgba(111, 111, 111, 0.04);
    }
  }
}

.part3-none {
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/components/part3/Part3.vue